export default __webpack_public_path__ + "static/media/ccf25ada-6d2a-4133-95dc-deb039e22999.1aa5ee9d.woff";